import List from "./List (2)";
import Title from "./Title (4)";

// ExtendedCancellationPeriod هاد الكومبون يلي بيحوي كلشي بقلبو وهي مكانا بالصفحة التانية 

function ExtendedCancellationPeriod({price,title,setPrice3}) {
  
  return (
<div className="container mx-auto mt-4 mb-5 py-4 md:px-6 px-2 bg-[#a47a24] text-white font-bold rounded shadow-md">
{/* <Title title={title} price={price} sett={setPrice3}/>  */}
      <List/>
      <div className="flex justify-end">
        {/* <p className="md:text-[20px] text-[12px] font-semibold">{price} €</p> */}
      </div>
    </div>
  );
}

export default ExtendedCancellationPeriod;
